import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({ baseURL: API_BASE, timeout: 15000, headers: { 'Content-Type': 'application/json' } });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('chat_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
}, error => Promise.reject(error));

api.interceptors.response.use(response => response, error => {
  if (error.response?.status === 401) {
    localStorage.removeItem('chat_token');
    localStorage.removeItem('chat_user');
    window.location.href = '/login';
  }
  return Promise.reject(error);
});

export const authAPI = {
  register: d => api.post('/auth/register', d),
  login: d => api.post('/auth/login', d),
  adminLogin: d => api.post('/auth/admin/login', d),
  getMe: () => api.get('/auth/me')
};

export const usersAPI = {
  getAll: p => api.get('/users', { params: p }),
  getById: id => api.get(`/users/${id}`),
  getDepartments: () => api.get('/users/departments'),
  updateProfile: d => api.put('/users/profile/update', d),
  uploadAvatar: fd => api.post('/users/avatar/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } }),
  changePassword: d => api.put('/users/password/change', d)
};

export const messagesAPI = {
  getOrCreateConversation: userId => api.post('/messages/conversation', { userId }),
  createGroup: d => api.post('/messages/group/create', d),
  broadcast: d => api.post('/messages/broadcast', d),
  getConversations: () => api.get('/messages/conversations'),
  getMessages: (convId, p) => api.get(`/messages/${convId}`, { params: p }),
  sendMessage: d => api.post('/messages/send', d),
  deleteMessage: id => api.delete(`/messages/${id}`),
  getUnreadCount: () => api.get('/messages/unread/count')
};

export const adminAPI = {
  getDashboard: () => api.get('/admin/dashboard'),
  getRegistrations: p => api.get('/admin/registrations', { params: p }),
  approveUser: id => api.put(`/admin/approve/${id}`),
  rejectUser: (id, reason) => api.put(`/admin/reject/${id}`, { reason }),
  getEmployees: p => api.get('/admin/employees', { params: p }),
  toggleEmployee: id => api.put(`/admin/employees/${id}/toggle`),
  deleteEmployee: id => api.delete(`/admin/employees/${id}`)
};

export default api;
